
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Get } from 'vuex-pathify';
import { marked } from 'marked';
import { IAppNotification } from '@/types/notifications.types';
import amplitudeService from '@/services/AmplitudeService';
import { format, parseISO } from 'date-fns';

@Component({ name: 'NotificationsList' })
export default class NotificationsList extends Vue {

    @Get('notifications/notifications')
    notifications: IAppNotification[];

    @Get('notifications/loading')
    loading: boolean;

    get sortedNotifications(): IAppNotification[] {
        return [...this.notifications].sort(
            (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
    }

    truncateBody(body: string): string {
        const html = marked.parse(body || '') as string;
        const plain = html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
        const words = plain.split(' ');
        if (words.length <= 25) return plain;
        return words.slice(0, 25).join(' ') + '…';
    }

    formatDate(dateStr: string): string {
        try {
            return format(parseISO(dateStr), 'MMM d, yyyy');
        } catch {
            return dateStr;
        }
    }

    openNotification(notification: IAppNotification): void {
        amplitudeService.trackNotificationRead(notification.subject);
        this.$emit('open-detail', notification);
    }

    async toggleRead(notification: IAppNotification): Promise<void> {
        if (notification.isRead) {
            await this.$store.dispatch('notifications/markUnread', notification.id);
        } else {
            await this.$store.dispatch('notifications/markRead', notification.id);
        }
    }

    async deleteNotification(id: number): Promise<void> {
        await this.$store.dispatch('notifications/deleteNotification', id);
    }

}
